var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex h-100 align-items-center justify-content-center"},[(_vm.groups.loading)?_c('spinner-block'):(_vm.groups.isEmpty())?_c('div',[_c('h5',[_vm._v(" "+_vm._s(_vm.$t('groups.errors.noGroups'))+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }